export type Locale = 'zh-CN' | 'en';

const zhCN = {
  'stage.firefly.title': '萤火码头',
  'stage.firefly.tagline': '光种进入码头中央光圈时，点击或触摸屏幕。',
  'stage.bubble.title': '泡泡厨房',
  'stage.bubble.tagline': '看准三口锅：气泡落入对应锅圈时点击。',
  'stage.cloud.title': '云端邮局',
  'stage.cloud.tagline': '信封进入邮戳线时，按箭头方向左右滑动。',
  'stage.greenhouse.title': '沉睡温室',
  'stage.greenhouse.tagline': '雨滴落下时按住，光圈升起时松开。',
  'audio.enable': '点击或触摸屏幕，启用声音',
  'audio.enableFailed': '声音未能启用，请再次点击或触摸',
  'smoke.touchPointer': '模拟 Android 触摸指针',
  'smoke.visibilityReject': '模拟后台恢复被拒绝',
  'smoke.stageInput': '模拟下一次关卡操作',
  'input.howTo': '电脑：鼠标左键　·　Android：触摸屏幕',
  'shortcuts': '快捷键：R 重新开始　D 调试信息　Esc 暂停',
  'language.switch': '切换语言',
  'mode.backToModes': '返回模式选择',
  'mode.tagline': '选择一种节奏，让花园继续生长。',
  'mode.rhythm': '节奏模式',
  'mode.rhythmDetail': '原创节奏关卡、本地音乐谱面与时序工具',
  'mode.running': '奔跑模式',
  'mode.runningDetail': '自由移动、自动战斗、收集成长与成果环',
  'mode.moreBySam': '更多作品 · 慢慢岛 ↗',
  'running.worldSelect': '选择花园',
  'running.journal': '生涯档案',
  'running.restCorner': '休息角',
  'running.resumeTitle': '继续未完成的旅程？',
  'running.resumeDetail': '上次停在 {world} · {difficulty} · 进度时间 {time}',
  'running.continueRun': '继续游戏',
  'running.startNewRun': '开始新游戏',
  'running.difficulty': '难度',
  'running.difficulty.sprout': '新芽',
  'running.difficulty.garden': '花园',
  'running.difficulty.storm': '风暴',
  'running.phd': '博士花园',
  'running.phdDetail': '首个可玩世界 · 正在生长',
  'running.master': '硕士花园',
  'running.masterDetail': '压缩学期 · 课程、项目与求职',
  'running.work': '工作花园',
  'running.slowly': '慢慢岛',
  'running.slowlyDetail': '认出感受与需要，留下一个可同行的同伴；没有失败。',
  'running.workDetail': '优先级切换 · 日报、周会与交付',
  'running.cultivation': '修行花园',
  'running.locked': '尚未开放',
  'running.loading': '正在进入博士花园…',
  'running.offlineUnavailable': '首次进入奔跑模式需要联网。成功进入一次后即可离线使用。',
  'running.loadFailed': '奔跑模式暂时无法启动。请返回模式选择后重试。',
  'running.retryOnline': '联网后重试',
  'running.help': 'WASD / 方向键 · 拖动移动',
  'running.level': '等级',
  'running.meeting': '组会',
  'running.audioOn': '奔跑模式声音已开启',
  'running.audioOff': '奔跑模式已静音',
  'running.emojiBeta': '🙂 Emoji（测试）',
  'running.legend.open': '打开图例',
  'running.legend.close': '关闭图例',
  'running.legend.title': '图例与进度',
  'running.legend.paused': '已暂停；关闭图例后继续。',
  'running.legend.status.complete': '已完成', 'running.legend.status.current': '进行中', 'running.legend.status.locked': '未解锁',
  'running.legend.energy': '能量', 'running.legend.energyDetail': '移动和行动会消耗，恢复后可以继续推进。',
  'running.legend.focus': '专注', 'running.legend.focusDetail': '支持稳定行动和完成目标。',
  'running.legend.spirit': '精神', 'running.legend.spiritDetail': '维持韧性，避免状态耗尽。',
  'running.legend.calendar': '日程负荷', 'running.legend.calendarDetail': '过多安排会压缩可用空间。',
  'running.legend.supervisor': '导师 / PI', 'running.legend.supervisorDetail': '稳定的长期指导者；支持与要求可以同时存在。',
  'running.legend.project': '进行中项目', 'running.legend.projectDetail': '完成项目会推进论文成长。',
  'running.legend.signal': '信号', 'running.legend.signalDetail': '清晰、可用的反馈会帮助判断。',
  'running.legend.noise': '噪声 / 污染', 'running.legend.noiseDetail': '无效压力会侵蚀状态，需要留意。',
  'running.legend.labMeeting': '组会', 'running.legend.labMeetingDetail': '先有预警，再进入反馈压力阶段。',
  'running.legend.milestone': '学术里程碑', 'running.legend.milestoneDetail': '年度节点会带来不同的推进目标。',
  'running.legend.orbit': '成果环', 'running.legend.orbitDetail': '围绕角色的成果会帮助对抗压力。',
  'running.legend.plan': '博士路径', 'running.legend.planDetail': '当前进度和下一步门槛。',
  'running.legend.plan.year1': '第一年：学年汇报', 'running.legend.plan.year1Detail': '完成后选择导师 / PI。',
  'running.legend.plan.year2': '第二年：组会', 'running.legend.plan.year2Detail': '与导师讨论反馈并调整当前推进。',
  'running.legend.plan.year3': '第三年：开题', 'running.legend.plan.year3Detail': '明确论文方向和计划。',
  'running.legend.plan.year4': '第四年：中期考核', 'running.legend.plan.year4Detail': '通过后进入后续学术推进。',
  'running.legend.plan.annual': '第四年后：年度组会', 'running.legend.plan.annualDetail': '此后每年回顾并调整论文进展。',
  'running.legend.plan.preDefense': '预答辩', 'running.legend.plan.preDefenseDetail': '满足论文、资格与证据条件后开启。',
  'running.legend.plan.revisions': '修改', 'running.legend.plan.revisionsDetail': '完成预答辩后处理剩余修改。',
  'running.legend.plan.defense': '答辩', 'running.legend.plan.defenseDetail': '修改完成后进入最终答辩。',
  'running.legend.requirement.qualifying': '未满足：通过中期考核', 'running.legend.requirement.thesis': '未满足：论文成长到开花', 'running.legend.requirement.independent': '未满足：独立研究准备度达到 30', 'running.legend.requirement.evidence': '未满足：证据达到 30', 'running.legend.requirement.preDefense': '未满足：通过预答辩', 'running.legend.requirement.revisions': '未满足：完成修改', 'running.legend.requirement.defense': '未满足：通过答辩', 'running.legend.requirementDetail': '这是毕业前仍需完成的条件。',
  'running.legend.master.course': '课程模块', 'running.legend.master.courseDetail': '课程压力会压缩时间和专注。',
  'running.legend.master.milestone': '学期节点', 'running.legend.master.milestoneDetail': '读清预警，准备关键挑战。',
  'running.legend.master.year1': '第一年：课程与入门项目', 'running.legend.master.year1Detail': '课程之外，开始研究、项目或实验室入门。',
  'running.legend.master.year2': '第二年：研究 / 项目', 'running.legend.master.year2Detail': '年底进入开题；硕士路径没有中期考核。',
  'running.legend.master.proposal': '开题', 'running.legend.master.proposalDetail': '准备、彩排，然后完成有限评审名单。',
  'running.legend.master.year3': '第三年：完成与规划', 'running.legend.master.year3Detail': '完成项目并处理毕业、就业或读博规划。',
  'running.legend.master.defense': '硕士答辩', 'running.legend.master.defenseDetail': '第三年末的最终有限考核。',
  'running.legend.master.careerPlan': '生涯计划', 'running.legend.master.careerPlanDetail': '研究 / 读博、就业或暂未决定会改变后续资源。',
  'running.legend.work.cycle': '工作周期', 'running.legend.work.cycleDetail': '当前周期决定需要处理的优先级。',
  'running.legend.work.deadline': '截止日期', 'running.legend.work.deadlineDetail': '快速逼近的时间压力，需要及时避开或处理。',
  'running.legend.work.weekly': '周会', 'running.legend.work.weeklyDetail': '预警圆环提示即将到来的工作反馈压力。',
  'running.legend.work.stage': '工作阶段', 'running.legend.work.stageDetail': 'Offer → 试用 / 实习 → 转正 → 晋升。',
  'running.legend.work.manager': '当前经理', 'running.legend.work.managerDetail': '经理会改变需求清晰度、资源、反馈、转正与晋升。',
  'running.legend.work.market': '就业市场', 'running.legend.work.marketDetail': '缓慢变化的弱 / 强环境；经验也会改善后续机会。',
  'running.legend.work.conversion': '转正', 'running.legend.work.conversionDetail': '表现、资源与经理会共同影响转正。',
  'running.legend.work.promotion': '晋升', 'running.legend.work.promotionDetail': '完成交付会推进晋升进度。',
  'running.legend.target.marker': '指定目标标记', 'running.legend.target.markerDetail': '空心 △ 标在必须处理的目标上；目标本体可以是不同形状。',
  'running.legend.target.reviewer': '评审意见', 'running.legend.target.reviewerDetail': '实心三角形本体；带有空心 △ 时属于当前考核的指定目标。',
  'running.legend.target.chair': '评审主席', 'running.legend.target.chairDetail': '圆角矩形本体；带有空心 △ 时属于当前考核的指定目标。',
  'running.legend.target.committee': '答辩委员会', 'running.legend.target.committeeDetail': '答辩中的大型圆形目标，代表委员会整体；并不是里程碑本身。',
  'running.choice.coursework': '课程优先',
  'running.choice.project': '项目优先',
  'running.choice.internship': '实习优先',
  'running.choice.jobSearch': '求职优先',
  'running.choice.protectFocus': '保护专注',
  'running.choice.acceptRush': '接受急件',
  'running.choice.takeBreak': '短暂休息',
  'running.choice.keepPushing': '继续推进',
  'running.choice.takeBreakDetail': '恢复少量能量与精神 · 日程向前移动',
  'running.choice.keepPushingDetail': '保留当前节奏 · 不进行道德评价',
  'running.choice.protectFocusDetail': '13 秒内恢复专注、减慢打断与日程增长，并稳定推进交付',
  'running.choice.acceptRushDetail': '立即推进交付；13 秒内持续损耗能量与专注、增加日程并产生更多请求',
  'running.choice.mei': '梅老师', 'running.choice.rowan': '罗文老师', 'running.choice.lin': '林老师',
  'running.choice.researchPhd': '研究 / 读博', 'running.choice.employment': '就业', 'running.choice.undecided': '暂未决定',
  'running.choice.offer-a': '结构型团队', 'running.choice.offer-b': '高速成长团队', 'running.choice.offer-c': '探索型团队',
  'running.choice.continue': '继续转正', 'running.choice.leaveSearch': '离开并继续寻找',
  'running.hint.weeklyWork': '周会\n先预警，再进入工作反馈压力阶段',
  'running.event.termRush': '期末冲刺',
  'running.event.daily': '日报',
  'running.event.weekly': '周会',
  'running.milestone.year1': '年度汇报',
  'running.milestone.year2': '开题',
  'running.milestone.year3': '中期考核',
  'running.milestone.annual': '年度组会',
  'running.preDefense': '预答辩',
  'running.revision': '最终修改',
  'running.supervisor': '导师 / PI',
  'running.supervisorHint': '导师 / PI\n决定反馈方式与组会压力',
  'running.hint.phone': '手机打断\n靠近会增加噪声与日程压力',
  'running.hint.reviewer': '评审意见\n处理评审压力，继续推进项目',
  'running.hint.committee': '答辩委员会\n读清预警，完成最终考验',
  'running.hint.courseBlock': '课程模块\n压缩时间与专注空间',
  'running.hint.deadline': '截止日期\n快速逼近的时间压力',
  'running.hint.request': '工作请求\n会打断当前优先级',
  'running.hint.notification': '通知\n短促而频繁的干扰',
  'running.hint.orbit': '成果环\n环绕成果会持续伤害附近压力',
  'running.hint.satellite': '完成成果\n已完成的项目会成为环绕卫星',
  'running.hint.resources': '⚡ 能量 · ◉ 专注 · ♡ 精神\n保持三项资源，才能持续前进',
  'running.hint.signal': '信号\n清晰、可用的反馈',
  'running.hint.noise': '噪声 / 污染\n无效压力会侵蚀状态',
  'running.hint.meeting': '组会\n先预警，再进入反馈压力阶段',
  'running.hint.activeProject': '进行中项目\n击败压力会推进项目',
  'running.hint.thesis': '论文成长\n完成不同类型项目，让论文开花',
  'running.hint.milestone': '学术里程碑\n准备、彩排，然后完成正式考核',
  'running.hint.portrait': '横屏可查看完整视野',
  'running.bossStudio': '自定义 Boss 工坊',
  'running.bossStudioDetail': '本地导入、预览、导出数据配置',
  'running.resetHints': '重置语义提示',
  'running.bossPaste': '粘贴 Boss JSON，或选择 .json 文件。所有内容仅保存在本机。',
  'running.bossFile': '选择 JSON 文件',
  'running.bossPreview': '校验并预览',
  'running.bossConfirm': '确认保存',
  'running.bossExport': '导出',
  'running.bossReplaceConflict': '同一 Boss ID 已存在；确认后将替换它。',
  'running.bossDelete': '删除',
  'running.bossCopyPrompt': '复制 AI 转换提示词',
  'running.bossHowToTitle': '如何创建 Boss',
  'running.bossHowToStepDescribe': '写下一个虚构或复合人物的情境与特征。',
  'running.bossHowToStepCopy': '复制提示词，粘贴到任意 AI 工具并填入描述。',
  'running.bossHowToStepPreview': '把返回的 JSON 粘贴回来，校验预览后再确认保存。',
  'running.bossHowToSafety': '只接受受限 JSON 数据；不会自动保存、执行代码或联网。',
  'running.bossUseExample': '载入有效示例',
  'running.bossCopyExample': '复制有效示例',
  'running.bossSchemaDocs': '查看 Boss 数据说明',
  'running.bossPromptCopied': 'AI 转换提示词已复制。',
  'running.bossExampleLoaded': '已载入本仓库维护的有效示例；仍需校验预览后确认保存。',
  'running.bossExampleCopied': '有效示例已复制。',
  'running.bossValid': '配置有效；请确认后保存。',
  'running.bossSaved': 'Boss 已保存在本机。',
  'running.promoteBoss': '将此时的我保存为 Boss',
  'running.promoteBossSaved': '已保存到 Boss 工坊',
  'running.bossFileInvalid': '文件：请选择一个不超过 100 KB 的 .json 文件。',
  'running.bossHp': '生命值',
  'running.bossSignal': '信号',
  'running.bossNoise': '噪声',
  'running.bossUnknownValue': '未知选项',
  'running.bossWorld.phd': '博士花园', 'running.bossWorld.master': '硕士花园', 'running.bossWorld.work': '工作花园',
  'running.bossOrigin.builtin': '内置', 'running.bossOrigin.custom': '自定义', 'running.bossOrigin.promotedPlayer': '玩家晋升',
  'running.bossShape.circle': '圆形', 'running.bossShape.triangle': '三角形', 'running.bossShape.square': '方形', 'running.bossShape.hexagon': '六边形',
  'running.bossAttack.radialPulse': '环形脉冲', 'running.bossAttack.directedBurst': '定向爆发', 'running.bossAttack.orbitingPressure': '环绕压力', 'running.bossAttack.laneSweep': '通道扫掠', 'running.bossAttack.interruptRing': '打断环',
  'running.bossWeakness.focus': '专注', 'running.bossWeakness.evidence': '证据', 'running.bossWeakness.clarity': '清晰', 'running.bossWeakness.boundary': '边界', 'running.bossWeakness.connection': '联结', 'running.bossWeakness.mobility': '行动力',
  'running.bossField.root': '根对象', 'running.bossField.schema': '架构版本', 'running.bossField.id': '标识', 'running.bossField.name': '名称', 'running.bossField.nameEn': '英文名称', 'running.bossField.nameZh': '中文名称', 'running.bossField.origin': '来源', 'running.bossField.worlds': '花园', 'running.bossField.appearance': '外观', 'running.bossField.shape': '形状', 'running.bossField.icon': '图标', 'running.bossField.palette': '配色', 'running.bossField.stats': '数值', 'running.bossField.hp': '生命值', 'running.bossField.speed': '速度', 'running.bossField.scale': '体型', 'running.bossField.traits': '特质', 'running.bossField.expertise': '专业度', 'running.bossField.resources': '资源', 'running.bossField.clarity': '清晰度', 'running.bossField.autonomySupport': '自主支持', 'running.bossField.emotionalSafety': '情绪安全', 'running.bossField.fairness': '公平性', 'running.bossField.boundaryRespect': '边界尊重', 'running.bossField.projectMatch': '项目契合度', 'running.bossField.behavior': '行为', 'running.bossField.signal': '信号', 'running.bossField.noise': '噪声', 'running.bossField.attacks': '攻击', 'running.bossField.telegraphMs': '预警时间', 'running.bossField.phases': '阶段', 'running.bossField.weaknesses': '弱点', 'running.bossField.resistances': '抗性', 'running.bossField.reward': '奖励', 'running.bossField.rewardTitle': '奖励称号', 'running.bossField.profileTag': '档案标签',
  'running.bossError.fileTooLarge': '文件超过 100 KB 上限。', 'running.bossError.invalidJson': 'JSON 语法无效。', 'running.bossError.rootObject': '根对象必须是一个 JSON 对象。', 'running.bossError.unknownField': '不允许此字段；不能包含可执行或扩展内容。', 'running.bossError.schema': '架构版本不匹配。', 'running.bossError.identifier': '必须为 1–64 个字母、数字、点、下划线或连字符。', 'running.bossError.characters': '字符数必须为', 'running.bossError.expectedObject': '必须是对象。', 'running.bossError.palette': '必须是 1–4 个 #RRGGBB 颜色。', 'running.bossError.range': '数值必须介于', 'running.bossError.integer': '必须是整数。', 'running.bossError.allowedValues': '必须使用允许的选项及数量。', 'running.bossError.invalid': '配置无效。',
  'running.upgradeOrbit': '成果环',
  'running.upgradeCadence': '专注节奏',
  'running.upgradeVitality': '韧性',
  'running.resting': '花园休息中',
  'running.completed': '阶段完成 · 点击或按空格再来一次',
  'running.graduated': '毕业 · 花园通路已经打开',
  'running.finalWinter': '第九年终冬 · 本次旅程结束',
  'running.restartHint': '点击或按空格重新开始',
  'running.backToWorlds': '返回花园选择',
  'running.projectReplication': '复现方法',
  'running.projectIdea': '冒险新想法',
  'running.projectHelping': '协作支援',
  'running.projectPrestige': '声望机会',
  'running.qualifying': '中期考核',
  'running.defense': '答辩',
  'running.attempt': '进入',
  'running.defer': '稍后',
  'running.supervisorChoiceTitle': '年度汇报完成 · 选择主要导师',
  'running.supervisorChoiceTitleCompact': '选择主要导师',
  'running.supervisor.supportive': '协作型导师',
  'running.supervisor.supportiveDetail': '方向契合 · 资源可靠 · 鼓励自主',
  'running.supervisor.controlling': '强驱动型导师',
  'running.supervisor.controllingDetail': '方法扎实 · 资源充足 · 工作管理紧密',
  'running.supervisor.handsOff': '低接触型导师',
  'running.supervisor.handsOffDetail': '自主空间大 · 联系较少 · 结构支持有限',
  'running.supervisorRequestTitle': '导师提出一项额外任务',
  'running.supervisorRequest.accept': '接受任务',
  'running.supervisorRequest.boundary': '设定边界',
  'running.supervisorRequest.decline': '拒绝任务',
  'running.lifestyleTitle': '当前阶段资源承压 · 调整一段时间的习惯？',
  'running.lifestyleTitleCompact': '为当前阶段调整一项习惯',
  'running.lifestyle.rest': '休息 / 调整睡眠',
  'running.lifestyle.restDetail': '恢复能量与专注 · 占用近期时间',
  'running.lifestyle.exercise': '运动',
  'running.lifestyle.exerciseDetail': '恢复能量与精神 · 增加少量日程',
  'running.lifestyle.social': '社交',
  'running.lifestyle.socialDetail': '提升联结与精神 · 消耗时间和专注',
  'running.lifestyle.mindfulness': '静心',
  'running.lifestyle.mindfulnessDetail': '降低噪声与污染 · 放慢近期项目推进',
  'running.lifestyle.weekendOvertime': '周末加班',
  'running.lifestyle.weekendOvertimeDetail': '立即增加证据 · 损耗能量、精神并累积污染',
  'running.milestone.qualifyingObjective': '处理所有带空心 △ 标记的指定评审目标',
  'running.milestone.defenseObjective': '完成所有带空心 △ 标记的指定答辩目标',
  'running.thesis.seed': '种子',
  'running.thesis.sapling': '幼苗',
  'running.thesis.tree': '树',
  'running.thesis.bloom': '开花',
  'result.title': '本局结果',
  'result.score': '分数',
  'result.best': '本机最佳',
  'result.newBest': '刷新本机最佳',
  'result.accuracy': '准确率',
  'result.combo': '最高连击',
  'result.timing': '操作倾向',
  'result.timing.fast': '偏早',
  'result.timing.balanced': '稳定',
  'result.timing.slow': '偏晚',
  'result.details': '查看详细判定',
  'result.perfect': '完美',
  'result.great': '很棒',
  'result.ok': '可以',
  'result.miss': '错过',
  'result.meanError': '平均时间误差',
  'result.medianError': '时间误差中位数',
  'result.histogram': '时序分布',
  'action.restart': '重新开始',
  'action.nextStage': '下一关',
  'action.back': '返回关卡选择',
  'tutorial.action': '光种进入光圈时，点击或触摸！',
  'tutorial.watch': '跟着移动的光种，瞄准中央光圈',
  'tutorial.stage': '互动教学 · 前四次会逐步提示',
  'tutorial.wait': '再等等：光种还没进入光圈',
  'tutorial.interactive': '互动教学 · 完成操作后正式开始',
  'tutorial.firefly.action': '光种进入中央光圈时点击',
  'tutorial.firefly.detail': '电脑用鼠标左键 · Android 直接触摸',
  'tutorial.bubble.action': '点击正在发光的锅区',
  'tutorial.bubble.detail': '气泡与锅圈重合时再点击；点错区域会失败',
  'tutorial.cloud.left': '从右向左滑动',
  'tutorial.cloud.right': '从左向右滑动',
  'tutorial.cloud.detail': '沿虚线滑过足够距离，让信封穿过邮戳线',
  'tutorial.cloud.more': '继续滑动',
  'tutorial.cloud.ready': '距离足够 · 松开',
  'tutorial.greenhouse.action': '按住雨滴，光圈升起时松开',
  'tutorial.greenhouse.detail': '看到“按住中”后继续保持，直到释放目标到达',
  'tutorial.greenhouse.press': '按下并保持',
  'tutorial.greenhouse.holding': '按住中 · 等待释放',
  'tutorial.greenhouse.released': '已松开 · 看判定反馈',
  'tutorial.waitForTarget': '再等等 · 目标还没到',
  'tutorial.wrongLane': '点错锅区 · 看发光区域',
  'tutorial.wrongDirection': '方向不对 · 跟随箭头',
  'tutorial.holdEarly': '松开太早 · 继续按住',
  'tutorial.holdLate': '松开太晚 · 出口窗亮起时松手',
  'tutorial.tooEarly': '时机太早 · 等目标进入判定区',
  'tutorial.tooLate': '时机太晚 · 目标经过判定线时操作',
  'lane.left': '左锅',
  'lane.center': '中锅',
  'lane.right': '右锅',
  'feedback.PERFECT': '完美！',
  'feedback.GREAT': '很棒！',
  'feedback.OK': '可以！',
  'feedback.MISS': '错过！',
  'hud.combo': '连击',
  'hud.groove': '律动',
  'section.INTRO': '序章',
  'section.MAIN_A': '主段 A',
  'section.VARIATION_B': '变化 B',
  'section.CLIMAX': '高潮',
  'section.OUTRO': '收束',
  'timing.fast': '偏快',
  'timing.slow': '偏慢',
  'action.pause': '暂停',
  'action.resume': '继续',
  'status.paused': '已暂停',
  'debug.title': 'BeatGarden　时序调试',
  'debug.audioTime': '音频时间',
  'debug.transportTime': '乐曲时间',
  'debug.transportBeat': '当前节拍',
  'debug.frameRate': '帧率',
  'debug.calibration': '校准偏移',
  'debug.lastInputDelta': '最近输入误差',
  'debug.lastInputTime': '最近输入时间',
  'debug.lastTargetBeat': '最近目标节拍',
  'debug.lastTargetTime': '最近目标时间',
  'debug.lastJudgement': '最近判定',
  'debug.schedulerQueue': '调度队列',
  'debug.counts': '判定计数',
  'debug.events': '个事件',
  'error.missingRoot': '页面缺少游戏容器。',
  'autochart.title': '你的音乐',
  'autochart.subtitle': '选择设备上的音乐，在本地生成原创节奏谱面。',
  'autochart.choose': '选择音频文件',
  'autochart.privacy': '音乐只在本设备分析，不会上传。',
  'autochart.rights': '用户导入音乐：版权状态未核验，由用户提供。',
  'autochart.analyzing': '正在分析音乐…',
  'autochart.preparing': '正在准备音频…',
  'autochart.failed': '无法分析此音频文件。',
  'autochart.fileTooLarge': '文件过大；请选择 100 MB 以内的音频。',
  'autochart.audioTooLong': '音频过长；当前版本支持最长 15 分钟。',
  'autochart.tempo': '检测速度',
  'autochart.confidence': '置信度',
  'autochart.mode': '计时模式',
  'autochart.onsets': '候选起音',
  'autochart.notes': '生成音符',
  'autochart.difficulty': '难度',
  'autochart.easy': '轻松',
  'autochart.normal': '普通',
  'autochart.hard': '困难',
  'autochart.seed': '变化种子',
  'autochart.regenerate': '重新生成变化',
  'autochart.localMode': '起音直接计时',
  'autochart.beatMode': '节拍网格辅助',
  'autochart.back': '返回萤火码头',
  'autochart.play': '进入脉冲花园',
  'autochart.changeSong': '重新生成或更换音乐',
  'autochart.song': '歌曲',
  'autochart.localSong': '本地音乐',
  'autochart.chartStyle': '谱面风格',
  'autochart.style.tap': '清晰点按',
  'autochart.style.flow': '流动混合',
  'autochart.style.mixed': '手势交织',
  'autochart.generate': '生成谱面',
  'autochart.advanced': '高级设置与技术详情',
  'autochart.quality': '谱面质量',
  'autochart.rest': '留白',
  'autogarden.title': '脉冲花园',
  'autogarden.instructions': '光点进入中央花环时操作：圆点点击，箭头滑动，长条按住。',
  'autogarden.start': '点击或触摸，开始播放本地音乐',
  'autogarden.wait': '再等等：跟随正在靠近的光点',
  'autogarden.paused': '已暂停 · 再按 Esc 继续',
  'menu.tagline': '种下节拍，让花园回应你的每一次操作。',
  'menu.original': '原创关卡',
  'menu.originalDetail': '游玩 BeatGarden 原创音乐与互动场景',
  'menu.yourMusic': '你的音乐',
  'menu.yourMusicDetail': '在本地分析音频并生成谱面',
  'menu.stageSelect': '选择原创关卡',
  'menu.fireflyDetail': '互动教学 · 点击光种 · 原创程序音乐',
  'menu.bubbleDetail': '三轨点击 · 煮出会飞的节拍泡泡',
  'menu.cloudDetail': '方向滑动 · 把节拍信件送上云层',
  'menu.greenhouseDetail': '按住与松开 · 用雨声唤醒藤蔓',
  'menu.mechanic': '玩法',
  'menu.difficulty': '难度',
  'menu.bestAccuracy': '最佳准确率',
  'menu.bestGrade': '最佳评级',
  'menu.noRecord': '尚无记录',
  'menu.input.tap': '鼠标点击 / 触摸',
  'menu.input.swipe': '左右滑动',
  'menu.input.hold': '按住并松开',
  'menu.difficulty.warmup': '入门',
  'menu.difficulty.medium': '进阶',
  'menu.difficulty.focus': '专注',
  'menu.back': '返回主菜单',
  'menu.calibration': '时序校准',
  'menu.calibrationDetail': '用节拍点击测量设备与操作偏移',
  'menu.settings': '设置',
  'menu.settingsDetail': '音量、动态效果与本机偏好',
  'menu.audioTest': '音频与直播测试',
  'menu.audioTestDetail': '分别试听原创音乐与反馈音效',
  'menu.provenance': '素材、许可与直播安全',
  'menu.provenanceDetail': '查看内置内容和导入音乐的来源说明',
  'audioTest.title': '音频与直播测试',
  'audioTest.instructions': '启用声音后，分别试听原创程序音乐和游戏反馈音效。直播前请用自己的采集链路再次确认电平。',
  'audioTest.music': '播放音乐测试',
  'audioTest.sfx': '播放音效测试',
  'audioTest.locked': '声音尚未启用',
  'audioTest.ready': '声音已启用，可以分别试听',
  'audioTest.musicPlayed': '已播放原创程序音乐测试',
  'audioTest.sfxPlayed': '已播放程序音效测试',
  'provenance.title': '素材、许可与直播安全',
  'provenance.intro': 'BeatGarden 明确区分项目内置原创内容与用户自己选择的本地音乐。',
  'provenance.builtin': '内置原创音乐与画面',
  'provenance.streamSafe': '直播安全来源记录',
  'provenance.builtinDetail': '音乐、音效、图形与动画均由项目代码实时生成；仓库不含第三方音乐、采样、图片、字体或谱面。',
  'provenance.imported': '用户导入的本地音乐',
  'provenance.rightsUnknown': '权利状态未核验 — 由用户提供',
  'provenance.importedDetail': '文件只在本设备解码和分析，不会上传，也不会加入仓库。BeatGarden 不会把导入音乐标记为直播安全。',
  'provenance.disclaimer': '本页是来源与产品行为说明，不构成法律保证。直播或发布前，请确认你对所用音乐拥有必要权利。',
  'calibration.title': '时序校准',
  'calibration.instructions': '听到每次节拍声时立即点击或触摸。需要 16 次有效操作。',
  'calibration.start': '启用声音并开始校准',
  'calibration.progress': '有效操作',
  'calibration.saved': '校准完成并已保存',
  'calibration.failed': '有效操作不足，请重新校准',
  'calibration.offset': '校准偏移',
  'settings.title': '设置',
  'settings.music': '音乐音量',
  'settings.sfx': '音效音量',
  'settings.audioTitle': '音频',
  'settings.musicStyle': '音乐风格',
  'settings.musicStyle.classic': '花园经典',
  'settings.musicStyle.chiptune': 'Famicom / 芯片音乐',
  'settings.musicStyle.organic': '安静有机',
  'settings.dynamicIntensity': '动态强度',
  'settings.dynamicIntensity.full': '完整',
  'settings.dynamicIntensity.soft': '柔和',
  'settings.dynamicIntensity.off': '关闭',
  'settings.reducedMotion': '减少动态效果',
  'settings.saved': '设置已自动保存',
  'settings.tutorialTitle': '互动教学',
  'settings.tutorialDetail': '重置后，下次进入每个原创关卡会重新完成四个教学目标。',
  'settings.tutorialReset': '重新启用全部关卡教学',
  'settings.tutorialResetDone': '已重新启用；下次进入关卡时开始教学。',
  'settings.dataTitle': '数据与可移植性',
  'settings.dataDetail': '备份或恢复奔跑模式进度，以及可复用的人物与 Boss。节奏模式数据不会被导入替换。',
  'settings.exportSave': '导出存档',
  'settings.importSave': '选择存档 JSON',
  'settings.exportContent': '导出自定义内容',
  'settings.importContent': '选择自定义内容 JSON',
  'settings.preview': '预览导入',
  'settings.confirmImport': '确认替换奔跑模式数据',
  'settings.confirmContent': '确认导入内容',
  'settings.cancelImport': '取消',
  'settings.importReady': '文件有效。确认前不会修改任何数据。',
  'settings.importApplied': '导入完成。可返回奔跑模式继续游戏。',
  'settings.importFailed': '导入失败；当前数据未改变。',
  'settings.replaceProgress': '奔跑模式进度将被替换',
  'settings.restoreRun': '将恢复未完成的 {world} · {difficulty} · {time}',
  'settings.noCurrentRun': '文件中没有未完成旅程',
  'settings.contentCounts': '人物 {people} · Boss {bosses}',
  'settings.conflictRule': '同一稳定 ID 会在确认后替换；同名但不同 ID 会并存。',
  'settings.peopleTitle': '人物库',
  'settings.exportPerson': '导出人物',
  'settings.importPerson': '导入人物 JSON',
  'settings.deletePerson': '删除人物',
} as const;

const en: Record<keyof typeof zhCN, string> = {
  'stage.firefly.title': 'Firefly Dock',
  'stage.firefly.tagline': 'Click or touch when the glowing seed enters the center ring.',
  'stage.bubble.title': 'Bubble Kitchen',
  'stage.bubble.tagline': 'Tap the matching pot when each bubble enters its ring.',
  'stage.cloud.title': 'Cloud Post',
  'stage.cloud.tagline': 'Swipe with the arrow when the envelope reaches the postmark line.',
  'stage.greenhouse.title': 'Sleepy Greenhouse',
  'stage.greenhouse.tagline': 'Hold when rain lands, then release when the ring rises.',
  'audio.enable': 'Click or touch to enable audio',
  'audio.enableFailed': 'Audio could not start. Click or touch again.',
  'smoke.touchPointer': 'Simulate Android touch pointer',
  'smoke.visibilityReject': 'Simulate rejected background resume',
  'smoke.stageInput': 'Simulate next stage action',
  'input.howTo': 'Computer: left mouse button  ·  Android: touch the screen',
  'shortcuts': 'Shortcuts: R restart  D debug  Esc pause',
  'language.switch': 'Switch language',
  'mode.backToModes': 'Back to mode select',
  'mode.tagline': 'Choose a rhythm and keep the garden growing.',
  'mode.rhythm': 'Rhythm Mode',
  'mode.rhythmDetail': 'Original rhythm stages, local music charts, and timing tools',
  'mode.running': 'Running Mode',
  'mode.runningDetail': 'Free movement, automatic combat, pickups, and Portfolio Orbit',
  'mode.moreBySam': 'More by Sam · Slowly Island ↗',
  'running.worldSelect': 'Choose a Garden',
  'running.journal': 'Garden Journal',
  'running.restCorner': 'Rest Corner',
  'running.resumeTitle': 'Continue your unfinished run?',
  'running.resumeDetail': 'Last played: {world} · {difficulty} · run time {time}',
  'running.continueRun': 'Continue Run',
  'running.startNewRun': 'Start New Run',
  'running.difficulty': 'Difficulty',
  'running.difficulty.sprout': 'Sprout',
  'running.difficulty.garden': 'Garden',
  'running.difficulty.storm': 'Storm',
  'running.phd': 'PhD Garden',
  'running.phdDetail': 'First playable world · growing now',
  'running.master': 'Master Garden',
  'running.masterDetail': 'Compressed terms · courses, projects, and job search',
  'running.work': 'Work Garden',
  'running.slowly': 'Slowly Island',
  'running.slowlyDetail': 'Recognize feelings and needs, then leave with an optional companion. No failure.',
  'running.workDetail': 'Priority shifts · daily reports, weekly meetings, delivery',
  'running.cultivation': 'Cultivation Garden',
  'running.locked': 'Coming later',
  'running.loading': 'Entering PhD Garden…',
  'running.offlineUnavailable': 'Your first Running Mode launch needs a connection. After one successful launch, it works offline.',
  'running.loadFailed': 'Running Mode could not start. Return to mode select and try again.',
  'running.retryOnline': 'Retry when online',
  'running.help': 'WASD / arrows · drag to move',
  'running.level': 'LV',
  'running.meeting': 'LAB MEETING',
  'running.audioOn': 'Running audio enabled',
  'running.audioOff': 'Running audio muted',
  'running.emojiBeta': '🙂 Emoji (Beta)',
  'running.legend.open': 'Open legend',
  'running.legend.close': 'Close legend',
  'running.legend.title': 'Legend & progress',
  'running.legend.paused': 'Paused; close the legend to continue.',
  'running.legend.status.complete': 'Complete', 'running.legend.status.current': 'Current', 'running.legend.status.locked': 'Locked',
  'running.legend.energy': 'Energy', 'running.legend.energyDetail': 'Movement and actions use it; recover to keep progressing.',
  'running.legend.focus': 'Focus', 'running.legend.focusDetail': 'Supports steady actions and goal completion.',
  'running.legend.spirit': 'Spirit', 'running.legend.spiritDetail': 'Sustains resilience and prevents depletion.',
  'running.legend.calendar': 'Calendar load', 'running.legend.calendarDetail': 'Too many commitments reduce your room to act.',
  'running.legend.supervisor': 'Supervisor / PI', 'running.legend.supervisorDetail': 'One steady long-term guide; challenge and support can coexist.',
  'running.legend.project': 'Active project', 'running.legend.projectDetail': 'Finishing projects advances thesis growth.',
  'running.legend.signal': 'Signal', 'running.legend.signalDetail': 'Clear, useful feedback helps you decide.',
  'running.legend.noise': 'Noise / pollution', 'running.legend.noiseDetail': 'Unhelpful pressure erodes your state.',
  'running.legend.labMeeting': 'Lab Meeting', 'running.legend.labMeetingDetail': 'A warning comes before the feedback-pressure phase.',
  'running.legend.milestone': 'Academic milestone', 'running.legend.milestoneDetail': 'Annual checkpoints bring distinct progress goals.',
  'running.legend.orbit': 'Portfolio orbit', 'running.legend.orbitDetail': 'Achievements circling you help counter pressure.',
  'running.legend.plan': 'PhD path', 'running.legend.planDetail': 'Current progress and the next gates.',
  'running.legend.plan.year1': 'Year 1: First Year Talk', 'running.legend.plan.year1Detail': 'Then choose a supervisor / PI.',
  'running.legend.plan.year2': 'Year 2: Lab Meeting', 'running.legend.plan.year2Detail': 'Discuss feedback with the supervisor and adjust current work.',
  'running.legend.plan.year3': 'Year 3: Thesis Proposal', 'running.legend.plan.year3Detail': 'Set the thesis direction and plan.',
  'running.legend.plan.year4': 'Year 4: Qualifying Exam', 'running.legend.plan.year4Detail': 'Pass it to continue the academic path.',
  'running.legend.plan.annual': 'After Year 4: Annual Lab Meeting', 'running.legend.plan.annualDetail': 'Review and adjust thesis progress each year thereafter.',
  'running.legend.plan.preDefense': 'Pre-Defense', 'running.legend.plan.preDefenseDetail': 'Unlocks after thesis, qualifying, and evidence gates.',
  'running.legend.plan.revisions': 'Revisions', 'running.legend.plan.revisionsDetail': 'Address remaining revisions after readiness.',
  'running.legend.plan.defense': 'Defense', 'running.legend.plan.defenseDetail': 'Enter the final defense after revisions.',
  'running.legend.requirement.qualifying': 'Still needed: pass Qualifying Exam', 'running.legend.requirement.thesis': 'Still needed: thesis reaches bloom', 'running.legend.requirement.independent': 'Still needed: independent research readiness reaches 30', 'running.legend.requirement.evidence': 'Still needed: evidence reaches 30', 'running.legend.requirement.preDefense': 'Still needed: pass Pre-Defense', 'running.legend.requirement.revisions': 'Still needed: finish revisions', 'running.legend.requirement.defense': 'Still needed: pass Defense', 'running.legend.requirementDetail': 'This requirement remains before graduation.',
  'running.legend.master.course': 'Course block', 'running.legend.master.courseDetail': 'Course pressure compresses time and focus.',
  'running.legend.master.milestone': 'Term milestone', 'running.legend.master.milestoneDetail': 'Read the warning and prepare for the key challenge.',
  'running.legend.master.year1': 'Year 1: courses & onboarding project', 'running.legend.master.year1Detail': 'Begin research, a project, or lab onboarding alongside coursework.',
  'running.legend.master.year2': 'Year 2: research / project', 'running.legend.master.year2Detail': 'Ends with Proposal; the Master path has no Qualifying Exam.',
  'running.legend.master.proposal': 'Proposal', 'running.legend.master.proposalDetail': 'Prepare, rehearse, then resolve one finite reviewer roster.',
  'running.legend.master.year3': 'Year 3: finish & plan', 'running.legend.master.year3Detail': 'Finish the project and plan graduation, employment, or PhD study.',
  'running.legend.master.defense': 'Master Defense', 'running.legend.master.defenseDetail': 'The final bounded assessment at the end of Year 3.',
  'running.legend.master.careerPlan': 'Career Plan', 'running.legend.master.careerPlanDetail': 'Research / PhD, Employment, and Undecided alter later resources.',
  'running.legend.work.cycle': 'Work cycle', 'running.legend.work.cycleDetail': 'The current cycle sets the active priority.',
  'running.legend.work.deadline': 'Deadline', 'running.legend.work.deadlineDetail': 'Fast-moving schedule pressure to avoid or handle promptly.',
  'running.legend.work.weekly': 'Weekly Meeting', 'running.legend.work.weeklyDetail': 'The warning ring signals approaching work feedback pressure.',
  'running.legend.work.stage': 'Work stage', 'running.legend.work.stageDetail': 'Offer → internship / trial → conversion → promotion.',
  'running.legend.work.manager': 'Current manager', 'running.legend.work.managerDetail': 'The manager changes clarity, resources, feedback, conversion and promotion.',
  'running.legend.work.market': 'Job Market', 'running.legend.work.marketDetail': 'A slowly changing weak / strong environment; Experience also improves later options.',
  'running.legend.work.conversion': 'Conversion', 'running.legend.work.conversionDetail': 'Performance, resources, and the manager shape conversion.',
  'running.legend.work.promotion': 'Promotion', 'running.legend.work.promotionDetail': 'Completing Delivery advances promotion progress.',
  'running.legend.target.marker': 'Designated-target marker', 'running.legend.target.markerDetail': 'The hollow △ marks a required target; the target body may use a different shape.',
  'running.legend.target.reviewer': 'Reviewer feedback', 'running.legend.target.reviewerDetail': 'A filled triangle body. When marked with a hollow △, it is required in the current assessment.',
  'running.legend.target.chair': 'Review chair', 'running.legend.target.chairDetail': 'A rounded-rectangle body. When marked with a hollow △, it is required in the current assessment.',
  'running.legend.target.committee': 'Defense committee', 'running.legend.target.committeeDetail': 'The large circular Defense target represents the committee as a whole, not the milestone itself.',
  'running.choice.coursework': 'COURSEWORK FOCUS',
  'running.choice.project': 'PROJECT FOCUS',
  'running.choice.internship': 'INTERNSHIP FOCUS',
  'running.choice.jobSearch': 'JOB SEARCH FOCUS',
  'running.choice.protectFocus': 'PROTECT FOCUS',
  'running.choice.acceptRush': 'ACCEPT RUSH REQUEST',
  'running.choice.takeBreak': 'TAKE A BREAK',
  'running.choice.keepPushing': 'KEEP PUSHING',
  'running.choice.takeBreakDetail': 'Recover a little Energy and Spirit · Calendar moves forward',
  'running.choice.keepPushingDetail': 'Keep current momentum · no moral grade',
  'running.choice.protectFocusDetail': '13s of Focus recovery, fewer interruptions, slower Calendar growth, and steady Delivery progress',
  'running.choice.acceptRushDetail': 'Immediate Delivery progress; 13s of ongoing Energy/Focus drain and Calendar pressure, plus more Requests',
  'running.choice.mei': 'Dr. Mei', 'running.choice.rowan': 'Dr. Rowan', 'running.choice.lin': 'Dr. Lin',
  'running.choice.researchPhd': 'Research / PhD', 'running.choice.employment': 'Employment', 'running.choice.undecided': 'Undecided',
  'running.choice.offer-a': 'Structured team', 'running.choice.offer-b': 'Fast-growth team', 'running.choice.offer-c': 'Exploratory team',
  'running.choice.continue': 'Continue to conversion', 'running.choice.leaveSearch': 'Leave and keep searching',
  'running.hint.weeklyWork': 'WEEKLY MEETING\nA warning precedes the work-feedback pressure phase',
  'running.event.termRush': 'TERM RUSH',
  'running.event.daily': 'DAILY REPORT',
  'running.event.weekly': 'WEEKLY MEETING',
  'running.milestone.year1': 'FIRST YEAR TALK',
  'running.milestone.year2': 'THESIS PROPOSAL',
  'running.milestone.year3': 'QUALIFYING EXAM',
  'running.milestone.annual': 'ANNUAL LAB MEETING',
  'running.preDefense': 'PRE-DEFENSE',
  'running.revision': 'FINAL REVISIONS',
  'running.supervisor': 'PRIMARY SUPERVISOR / PI',
  'running.supervisorHint': 'PRIMARY SUPERVISOR / PI\nSets feedback style and Lab Meeting pressure',
  'running.hint.phone': 'PHONE INTERRUPTION\nAdds Noise and Calendar pressure nearby',
  'running.hint.reviewer': 'REVIEWER FEEDBACK\nClear review pressure to keep the project moving',
  'running.hint.committee': 'DEFENSE COMMITTEE\nRead the telegraph and meet the final challenge',
  'running.hint.courseBlock': 'COURSE BLOCK\nCompresses time and focus',
  'running.hint.deadline': 'DEADLINE\nFast-moving schedule pressure',
  'running.hint.request': 'WORK REQUEST\nInterrupts the active priority',
  'running.hint.notification': 'NOTIFICATION\nA short, frequent interruption',
  'running.hint.orbit': 'PORTFOLIO ORBIT\nOrbiting achievements damage nearby pressure',
  'running.hint.satellite': 'COMPLETED SATELLITE\nA finished project joins your orbit',
  'running.hint.resources': '⚡ ENERGY · ◉ FOCUS · ♡ SPIRIT\nBalance all three to keep moving',
  'running.hint.signal': 'SIGNAL\nClear, useful feedback',
  'running.hint.noise': 'NOISE / POLLUTION\nUnhelpful pressure erodes your state',
  'running.hint.meeting': 'LAB MEETING\nA warning precedes the feedback-pressure phase',
  'running.hint.activeProject': 'ACTIVE PROJECT\nDefeating pressure advances the work',
  'running.hint.thesis': 'THESIS GROWTH\nComplete different project types to reach bloom',
  'running.hint.milestone': 'ACADEMIC MILESTONE\nPrepare, rehearse, then clear the presentation',
  'running.hint.portrait': 'Rotate to landscape for the full view',
  'running.bossStudio': 'CUSTOM BOSS STUDIO',
  'running.bossStudioDetail': 'Import, preview, and export local data profiles',
  'running.resetHints': 'Reset semantic hints',
  'running.bossPaste': 'Paste Boss JSON or choose a .json file. Everything stays on this device.',
  'running.bossFile': 'Choose JSON file',
  'running.bossPreview': 'Validate & preview',
  'running.bossConfirm': 'Confirm save',
  'running.bossExport': 'Export',
  'running.bossReplaceConflict': 'A Boss with this ID exists; confirming will replace it.',
  'running.bossDelete': 'Delete',
  'running.bossCopyPrompt': 'Copy AI conversion prompt',
  'running.bossHowToTitle': 'How to create a Boss',
  'running.bossHowToStepDescribe': 'Describe a fictional or composite person and their setting.',
  'running.bossHowToStepCopy': 'Copy the prompt, paste it into any AI tool, and add your description.',
  'running.bossHowToStepPreview': 'Paste the returned JSON here, validate the preview, then confirm the save.',
  'running.bossHowToSafety': 'Only bounded JSON data is accepted; nothing saves automatically, executes, or connects.',
  'running.bossUseExample': 'Load valid example',
  'running.bossCopyExample': 'Copy valid example',
  'running.bossSchemaDocs': 'View Boss data guide',
  'running.bossPromptCopied': 'AI conversion prompt copied.',
  'running.bossExampleLoaded': 'Loaded the maintained valid example; validate its preview before confirming a save.',
  'running.bossExampleCopied': 'Valid example copied.',
  'running.bossValid': 'Valid configuration; confirm to save.',
  'running.bossSaved': 'Boss saved on this device.',
  'running.promoteBoss': 'SAVE THIS VERSION OF ME AS A BOSS',
  'running.promoteBossSaved': 'SAVED TO BOSS STUDIO',
  'running.bossFileInvalid': 'File: choose one .json file up to 100 KB.',
  'running.bossHp': 'HP',
  'running.bossSignal': 'Signal',
  'running.bossNoise': 'Noise',
  'running.bossUnknownValue': 'Unknown option',
  'running.bossWorld.phd': 'PhD Garden', 'running.bossWorld.master': 'Master\'s Garden', 'running.bossWorld.work': 'Work Garden',
  'running.bossOrigin.builtin': 'Built-in', 'running.bossOrigin.custom': 'Custom', 'running.bossOrigin.promotedPlayer': 'Player-promoted',
  'running.bossShape.circle': 'Circle', 'running.bossShape.triangle': 'Triangle', 'running.bossShape.square': 'Square', 'running.bossShape.hexagon': 'Hexagon',
  'running.bossAttack.radialPulse': 'Radial pulse', 'running.bossAttack.directedBurst': 'Directed burst', 'running.bossAttack.orbitingPressure': 'Orbiting pressure', 'running.bossAttack.laneSweep': 'Lane sweep', 'running.bossAttack.interruptRing': 'Interrupt ring',
  'running.bossWeakness.focus': 'Focus', 'running.bossWeakness.evidence': 'Evidence', 'running.bossWeakness.clarity': 'Clarity', 'running.bossWeakness.boundary': 'Boundary', 'running.bossWeakness.connection': 'Connection', 'running.bossWeakness.mobility': 'Mobility',
  'running.bossField.root': 'Root object', 'running.bossField.schema': 'Schema', 'running.bossField.id': 'ID', 'running.bossField.name': 'Name', 'running.bossField.nameEn': 'English name', 'running.bossField.nameZh': 'Chinese name', 'running.bossField.origin': 'Origin', 'running.bossField.worlds': 'Worlds', 'running.bossField.appearance': 'Appearance', 'running.bossField.shape': 'Shape', 'running.bossField.icon': 'Icon', 'running.bossField.palette': 'Palette', 'running.bossField.stats': 'Stats', 'running.bossField.hp': 'HP', 'running.bossField.speed': 'Speed', 'running.bossField.scale': 'Scale', 'running.bossField.traits': 'Traits', 'running.bossField.expertise': 'Expertise', 'running.bossField.resources': 'Resources', 'running.bossField.clarity': 'Clarity', 'running.bossField.autonomySupport': 'Autonomy support', 'running.bossField.emotionalSafety': 'Emotional safety', 'running.bossField.fairness': 'Fairness', 'running.bossField.boundaryRespect': 'Boundary respect', 'running.bossField.projectMatch': 'Project match', 'running.bossField.behavior': 'Behavior', 'running.bossField.signal': 'Signal', 'running.bossField.noise': 'Noise', 'running.bossField.attacks': 'Attacks', 'running.bossField.telegraphMs': 'Telegraph time', 'running.bossField.phases': 'Phases', 'running.bossField.weaknesses': 'Weaknesses', 'running.bossField.resistances': 'Resistances', 'running.bossField.reward': 'Reward', 'running.bossField.rewardTitle': 'Reward title', 'running.bossField.profileTag': 'Profile tag',
  'running.bossError.fileTooLarge': 'File exceeds the 100 KB limit.', 'running.bossError.invalidJson': 'Invalid JSON syntax.', 'running.bossError.rootObject': 'The root must be one JSON object.', 'running.bossError.unknownField': 'This field is not allowed; executable or extension content is not permitted.', 'running.bossError.schema': 'Schema version does not match.', 'running.bossError.identifier': 'Must be 1–64 letters, numbers, dots, underscores, or hyphens.', 'running.bossError.characters': 'Character count must be', 'running.bossError.expectedObject': 'Must be an object.', 'running.bossError.palette': 'Must be 1–4 #RRGGBB colors.', 'running.bossError.range': 'Value must be between', 'running.bossError.integer': 'Must be an integer.', 'running.bossError.allowedValues': 'Use only allowed options and counts.', 'running.bossError.invalid': 'Invalid configuration.',
  'running.upgradeOrbit': 'PORTFOLIO ORBIT',
  'running.upgradeCadence': 'FOCUS CADENCE',
  'running.upgradeVitality': 'RESILIENCE',
  'running.resting': 'GARDEN RESTING',
  'running.completed': 'MILESTONE COMPLETE · tap or press Space',
  'running.graduated': 'GRADUATED · the garden path is open',
  'running.finalWinter': 'YEAR NINE FINAL WINTER · this run has ended',
  'running.restartHint': 'tap or press Space',
  'running.backToWorlds': 'Back to world select',
  'running.projectReplication': 'METHOD REPLICATION',
  'running.projectIdea': 'RISKY NEW IDEA',
  'running.projectHelping': 'COLLABORATE',
  'running.projectPrestige': 'PRESTIGE PROJECT',
  'running.qualifying': 'QUALIFYING EXAM',
  'running.defense': 'DEFENSE',
  'running.attempt': 'ENTER',
  'running.defer': 'LATER',
  'running.supervisorChoiceTitle': 'FIRST YEAR TALK COMPLETE · CHOOSE A PRIMARY SUPERVISOR',
  'running.supervisorChoiceTitleCompact': 'CHOOSE A PRIMARY SUPERVISOR',
  'running.supervisor.supportive': 'COLLABORATIVE SUPERVISOR',
  'running.supervisor.supportiveDetail': 'Strong fit · reliable resources · supports autonomy',
  'running.supervisor.controlling': 'HIGH-DRIVE SUPERVISOR',
  'running.supervisor.controllingDetail': 'Strong methods · ample resources · tightly managed work',
  'running.supervisor.handsOff': 'LOW-CONTACT SUPERVISOR',
  'running.supervisor.handsOffDetail': 'Wide autonomy · infrequent contact · limited structure',
  'running.supervisorRequestTitle': 'Your supervisor offers extra assigned work',
  'running.supervisorRequest.accept': 'Accept work',
  'running.supervisorRequest.boundary': 'Set boundary',
  'running.supervisorRequest.decline': 'Decline work',
  'running.lifestyleTitle': 'THIS PHASE IS STRAINING YOUR RESOURCES · ADJUST A HABIT FOR A WHILE?',
  'running.lifestyleTitleCompact': 'ADJUST ONE HABIT FOR THIS PHASE',
  'running.lifestyle.rest': 'REST / IMPROVE SLEEP',
  'running.lifestyle.restDetail': 'Recover Energy and Focus · spend near-term time',
  'running.lifestyle.exercise': 'EXERCISE',
  'running.lifestyle.exerciseDetail': 'Recover Energy and Spirit · add some Calendar load',
  'running.lifestyle.social': 'SOCIAL CONNECTION',
  'running.lifestyle.socialDetail': 'Build Connection and Spirit · spend time and Focus',
  'running.lifestyle.mindfulness': 'MINDFULNESS',
  'running.lifestyle.mindfulnessDetail': 'Reduce Noise and Pollution · slow near-term project work',
  'running.lifestyle.weekendOvertime': 'WEEKEND OVERTIME',
  'running.lifestyle.weekendOvertimeDetail': 'Gain Evidence now · lose Energy and Spirit, add Pollution',
  'running.milestone.qualifyingObjective': 'Resolve every required review target marked with a hollow △',
  'running.milestone.defenseObjective': 'Resolve every required defense target marked with a hollow △',
  'running.thesis.seed': 'SEED',
  'running.thesis.sapling': 'SAPLING',
  'running.thesis.tree': 'TREE',
  'running.thesis.bloom': 'BLOOM',
  'result.title': 'Result',
  'result.score': 'Score',
  'result.best': 'Local best',
  'result.newBest': 'New local best',
  'result.accuracy': 'Accuracy',
  'result.combo': 'Best combo',
  'result.timing': 'Timing tendency',
  'result.timing.fast': 'Early',
  'result.timing.balanced': 'Balanced',
  'result.timing.slow': 'Late',
  'result.details': 'View judgement details',
  'result.perfect': 'Perfect',
  'result.great': 'Great',
  'result.ok': 'OK',
  'result.miss': 'Miss',
  'result.meanError': 'Mean timing error',
  'result.medianError': 'Median timing error',
  'result.histogram': 'Timing distribution',
  'action.restart': 'Restart',
  'action.nextStage': 'Next stage',
  'action.back': 'Back to stage select',
  'tutorial.action': 'Click or touch when the seed enters the ring!',
  'tutorial.watch': 'Follow the moving seed toward the center ring',
  'tutorial.stage': 'Interactive tutorial · the first four cues are guided',
  'tutorial.wait': 'Not yet — wait until the seed enters the ring',
  'tutorial.interactive': 'Interactive tutorial · formal play starts after success',
  'tutorial.firefly.action': 'Click when the seed enters the center ring',
  'tutorial.firefly.detail': 'Desktop: left mouse button · Android: touch directly',
  'tutorial.bubble.action': 'Click the glowing pot zone',
  'tutorial.bubble.detail': 'Wait for the bubble to meet its ring; the wrong zone fails',
  'tutorial.cloud.left': 'Swipe from right to left',
  'tutorial.cloud.right': 'Swipe from left to right',
  'tutorial.cloud.detail': 'Follow the dashed trail far enough through the postmark line',
  'tutorial.cloud.more': 'KEEP SWIPING',
  'tutorial.cloud.ready': 'FAR ENOUGH · RELEASE',
  'tutorial.greenhouse.action': 'Press the raindrop, then release at the rising ring',
  'tutorial.greenhouse.detail': 'Keep holding after HOLDING appears, until the release target arrives',
  'tutorial.greenhouse.press': 'PRESS AND HOLD',
  'tutorial.greenhouse.holding': 'HOLDING · WAIT TO RELEASE',
  'tutorial.greenhouse.released': 'RELEASED · CHECK THE RESULT',
  'tutorial.waitForTarget': 'NOT YET · WAIT FOR THE TARGET',
  'tutorial.wrongLane': 'WRONG POT · FOLLOW THE GLOW',
  'tutorial.wrongDirection': 'WRONG WAY · FOLLOW THE ARROW',
  'tutorial.holdEarly': 'TOO EARLY · KEEP HOLDING',
  'tutorial.holdLate': 'TOO LATE · RELEASE WHILE THE WINDOW IS LIT',
  'tutorial.tooEarly': 'TOO EARLY · WAIT FOR THE HIT ZONE',
  'tutorial.tooLate': 'TOO LATE · ACT AS THE TARGET CROSSES',
  'lane.left': 'LEFT POT',
  'lane.center': 'CENTER POT',
  'lane.right': 'RIGHT POT',
  'feedback.PERFECT': 'PERFECT!',
  'feedback.GREAT': 'GREAT!',
  'feedback.OK': 'OK!',
  'feedback.MISS': 'MISS!',
  'hud.combo': 'COMBO',
  'hud.groove': 'GROOVE',
  'section.INTRO': 'INTRO',
  'section.MAIN_A': 'MAIN A',
  'section.VARIATION_B': 'VARIATION B',
  'section.CLIMAX': 'CLIMAX',
  'section.OUTRO': 'OUTRO',
  'timing.fast': 'FAST',
  'timing.slow': 'SLOW',
  'action.pause': 'Pause',
  'action.resume': 'Resume',
  'status.paused': 'Paused',
  'debug.title': 'BeatGarden  Timing Debug',
  'debug.audioTime': 'Audio time',
  'debug.transportTime': 'Song time',
  'debug.transportBeat': 'Transport beat',
  'debug.frameRate': 'Frame rate',
  'debug.calibration': 'Calibration offset',
  'debug.lastInputDelta': 'Last input delta',
  'debug.lastInputTime': 'Last input time',
  'debug.lastTargetBeat': 'Last target beat',
  'debug.lastTargetTime': 'Last target time',
  'debug.lastJudgement': 'Last judgement',
  'debug.schedulerQueue': 'Scheduler queue',
  'debug.counts': 'Judgement counts',
  'debug.events': 'events',
  'error.missingRoot': 'The game container is missing.',
  'autochart.title': 'Your Music',
  'autochart.subtitle': 'Choose music on this device and generate an original rhythm chart locally.',
  'autochart.choose': 'Choose audio file',
  'autochart.privacy': 'Music is analyzed only on this device and is never uploaded.',
  'autochart.rights': 'User-imported music: rights not verified; provided by the user.',
  'autochart.analyzing': 'Analyzing music…',
  'autochart.preparing': 'Preparing audio…',
  'autochart.failed': 'This audio file could not be analyzed.',
  'autochart.fileTooLarge': 'The file is too large. Choose audio up to 100 MB.',
  'autochart.audioTooLong': 'The audio is too long. This version supports up to 15 minutes.',
  'autochart.tempo': 'Detected tempo',
  'autochart.confidence': 'Confidence',
  'autochart.mode': 'Timing mode',
  'autochart.onsets': 'Onset candidates',
  'autochart.notes': 'Generated notes',
  'autochart.difficulty': 'Difficulty',
  'autochart.easy': 'Easy',
  'autochart.normal': 'Normal',
  'autochart.hard': 'Hard',
  'autochart.seed': 'Variation seed',
  'autochart.regenerate': 'Regenerate variation',
  'autochart.localMode': 'Direct onset timing',
  'autochart.beatMode': 'Beat-grid assisted',
  'autochart.back': 'Back to Firefly Dock',
  'autochart.play': 'Enter Pulse Garden',
  'autochart.changeSong': 'Regenerate or change song',
  'autochart.song': 'Song',
  'autochart.localSong': 'Local song',
  'autochart.chartStyle': 'Chart style',
  'autochart.style.tap': 'Clear taps',
  'autochart.style.flow': 'Flowing mix',
  'autochart.style.mixed': 'Gesture weave',
  'autochart.generate': 'Generate chart',
  'autochart.advanced': 'Advanced settings & technical details',
  'autochart.quality': 'Chart quality',
  'autochart.rest': 'rest',
  'autogarden.title': 'Pulse Garden',
  'autogarden.instructions': 'Act when a light enters the center wreath: tap circles, swipe arrows, hold bars.',
  'autogarden.start': 'Click or touch to play local music',
  'autogarden.wait': 'Not yet — follow the approaching light',
  'autogarden.paused': 'Paused · press Esc to continue',
  'menu.tagline': 'Plant the beat and let the garden answer every move.',
  'menu.original': 'Original Stages',
  'menu.originalDetail': 'Play BeatGarden original music and interactive scenes',
  'menu.yourMusic': 'Your Music',
  'menu.yourMusicDetail': 'Analyze local audio and generate a chart on this device',
  'menu.stageSelect': 'Choose an Original Stage',
  'menu.fireflyDetail': 'Interactive tutorial · tap glowing seeds · original procedural music',
  'menu.bubbleDetail': 'Three-lane taps · cook rhythm bubbles that take flight',
  'menu.cloudDetail': 'Directional swipes · deliver beat letters into the clouds',
  'menu.greenhouseDetail': 'Hold and release · wake vines with musical rain',
  'menu.mechanic': 'Mechanic',
  'menu.difficulty': 'Difficulty',
  'menu.bestAccuracy': 'Best accuracy',
  'menu.bestGrade': 'Best grade',
  'menu.noRecord': 'No record yet',
  'menu.input.tap': 'Mouse click / touch',
  'menu.input.swipe': 'Swipe left or right',
  'menu.input.hold': 'Hold and release',
  'menu.difficulty.warmup': 'Warm-up',
  'menu.difficulty.medium': 'Medium',
  'menu.difficulty.focus': 'Focus',
  'menu.back': 'Back to main menu',
  'menu.calibration': 'Timing Calibration',
  'menu.calibrationDetail': 'Measure device and input offset with guided taps',
  'menu.settings': 'Settings',
  'menu.settingsDetail': 'Volume, motion, and local preferences',
  'menu.audioTest': 'Audio & Streaming Test',
  'menu.audioTestDetail': 'Audition original music and feedback effects separately',
  'menu.provenance': 'Assets, Licenses & Stream Safety',
  'menu.provenanceDetail': 'See provenance for built-in and imported music',
  'audioTest.title': 'Audio & Streaming Test',
  'audioTest.instructions': 'Enable audio, then audition original procedural music and game feedback separately. Verify levels again through your own capture chain before streaming.',
  'audioTest.music': 'Play music test',
  'audioTest.sfx': 'Play SFX test',
  'audioTest.locked': 'Audio is not enabled yet',
  'audioTest.ready': 'Audio enabled; both checks are ready',
  'audioTest.musicPlayed': 'Original procedural music test played',
  'audioTest.sfxPlayed': 'Procedural SFX test played',
  'provenance.title': 'Assets, Licenses & Stream Safety',
  'provenance.intro': 'BeatGarden clearly separates built-in original content from music chosen locally by the user.',
  'provenance.builtin': 'Built-in Original Music & Visuals',
  'provenance.streamSafe': 'STREAM SAFE provenance',
  'provenance.builtinDetail': 'Music, sound effects, graphics, and animation are generated by project code. The repository contains no third-party music, samples, images, fonts, or beatmaps.',
  'provenance.imported': 'User-Imported Local Music',
  'provenance.rightsUnknown': 'RIGHTS NOT VERIFIED — user-provided',
  'provenance.importedDetail': 'Files are decoded and analyzed only on this device. They are not uploaded or added to the repository. BeatGarden never labels imported music as stream safe.',
  'provenance.disclaimer': 'This is a provenance and product-behavior statement, not a legal guarantee. Confirm that you hold the necessary rights before streaming or publishing music.',
  'calibration.title': 'Timing Calibration',
  'calibration.instructions': 'Click or touch immediately when you hear each tick. Sixteen valid inputs are required.',
  'calibration.start': 'Enable audio and start calibration',
  'calibration.progress': 'Valid inputs',
  'calibration.saved': 'Calibration complete and saved',
  'calibration.failed': 'Not enough valid inputs. Please run calibration again.',
  'calibration.offset': 'Calibration offset',
  'settings.title': 'Settings',
  'settings.music': 'Music volume',
  'settings.sfx': 'Sound effects volume',
  'settings.audioTitle': 'Audio',
  'settings.musicStyle': 'Music Style',
  'settings.musicStyle.classic': 'Garden Classic',
  'settings.musicStyle.chiptune': 'Famicom / Chiptune',
  'settings.musicStyle.organic': 'Quiet Organic',
  'settings.dynamicIntensity': 'Dynamic Intensity',
  'settings.dynamicIntensity.full': 'Full',
  'settings.dynamicIntensity.soft': 'Soft',
  'settings.dynamicIntensity.off': 'Off',
  'settings.reducedMotion': 'Reduce motion',
  'settings.saved': 'Settings save automatically',
  'settings.tutorialTitle': 'Interactive tutorials',
  'settings.tutorialDetail': 'After reset, each original stage will require its four tutorial targets next time.',
  'settings.tutorialReset': 'Re-enable all stage tutorials',
  'settings.tutorialResetDone': 'Re-enabled. The tutorial will start next time you enter a stage.',
  'settings.dataTitle': 'Data & Portability',
  'settings.dataDetail': 'Back up or restore Running progress and reusable People/Bosses. Rhythm data is never replaced by these imports.',
  'settings.exportSave': 'Export Save',
  'settings.importSave': 'Choose Save JSON',
  'settings.exportContent': 'Export Custom Content',
  'settings.importContent': 'Choose Custom Content JSON',
  'settings.preview': 'Import preview',
  'settings.confirmImport': 'Confirm Running replacement',
  'settings.confirmContent': 'Confirm content import',
  'settings.cancelImport': 'Cancel',
  'settings.importReady': 'The file is valid. Nothing changes until you confirm.',
  'settings.importApplied': 'Import complete. Return to Running to continue.',
  'settings.importFailed': 'Import failed; current data was not changed.',
  'settings.replaceProgress': 'Running progress will be replaced',
  'settings.restoreRun': 'Restores unfinished {world} · {difficulty} · {time}',
  'settings.noCurrentRun': 'No unfinished journey in this file',
  'settings.contentCounts': 'People {people} · Bosses {bosses}',
  'settings.conflictRule': 'A matching stable ID is replaced after confirmation; matching names with different IDs coexist.',
  'settings.peopleTitle': 'People library',
  'settings.exportPerson': 'Export Person',
  'settings.importPerson': 'Import Person JSON',
  'settings.deletePerson': 'Delete Person',
};

export type StringKey = keyof typeof zhCN;

let activeLocale: Locale = loadLocale();

function browserStorage(): Storage | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}

function loadLocale(): Locale {
  const storage = browserStorage();
  if (!storage || typeof storage.getItem !== 'function') return 'zh-CN';
  return storage.getItem('beatgarden.locale') === 'en' ? 'en' : 'zh-CN';
}

function syncDocumentLanguage(): void {
  if (typeof document !== 'undefined') document.documentElement.lang = activeLocale;
}

export function getLocale(): Locale {
  return activeLocale;
}

export function setLocale(locale: Locale): void {
  activeLocale = locale;
  const storage = browserStorage();
  if (storage && typeof storage.setItem === 'function') {
    storage.setItem('beatgarden.locale', locale);
  }
  syncDocumentLanguage();
}

export function toggleLocale(): Locale {
  const next = activeLocale === 'zh-CN' ? 'en' : 'zh-CN';
  setLocale(next);
  return next;
}

export function languageTargetLabel(): 'English' | '中文' {
  return activeLocale === 'zh-CN' ? 'English' : '中文';
}

export function languageTargetAction(): string {
  return activeLocale === 'zh-CN' ? 'Switch to English' : '切换到中文';
}

export function t(key: StringKey): string {
  return activeLocale === 'zh-CN' ? zhCN[key] : en[key];
}

syncDocumentLanguage();
